module.exports = __webpack_public_path__ + "static/media/18ECA36.a98861d8.jpg";